import React from "react"

import ProjectBreadcrumb from "./ProjectBreadcrumb.component"
import ProjectStatus from "./ProjectStatus.component"
import ProjectActions from "./ProjectActions.component"

interface ProjectDetailsHeaderProps {
  /** Users of the unit, for the Members dialog and the Copy and Move dialogs. */
  userData: string[]
}

/**
 * The project page's header row, one line that never wraps: the breadcrumb
 * with the project name and its status on the left, Members and the "⋯"
 * menu (Copy, Move, Delete) on the right. No action here is the page's main
 * one, so no button is solid. The breadcrumb is what gives way.
 */
const ProjectDetailsHeader: React.FC<ProjectDetailsHeaderProps> = ({
  userData,
}) => (
  <div className="flex flex-row flex-nowrap items-center gap-3 min-w-0">
    {/* antd lets a breadcrumb wrap; this one stays on the header's line, and
        the project name (the last crumb) may shrink and truncate. */}
    <div className="min-w-0 overflow-hidden [&_li:last-child]:min-w-0 [&_ol]:flex-nowrap [&_ol]:min-w-0">
      <ProjectBreadcrumb />
    </div>
    <div className="flex-none">
      <ProjectStatus />
    </div>
    <div className="ml-auto flex-none">
      <ProjectActions userData={userData} />
    </div>
  </div>
)

export default ProjectDetailsHeader
